import { Components, customHooks } from "@thisgorilla/primate-ds";
import { useRef, useState } from "react";

import { HOC } from "../../../../../../HOC";
import { FlexColumnWithTransition } from "../../../../../Common/Styles";
import NewsFeedFilterProps from "../NewsFeedFilter";
import List from "./List";
import RemoveCircle from "./RemoveCircle";
import { CircleListContainer } from "./style";

const CircleList = ({
  setCircleListOpen,
}: NewsFeedFilterProps.CircleListProps) => {
  const circleListRef = useRef(null);

  const [containerHeight, setContainerHeight] = useState(0);

  const [stepKey, setStepKey] = useState("");

  customHooks.useClickOutside({
    ref: circleListRef,
    setState: setCircleListOpen,
  });

  return (
    <CircleListContainer ref={circleListRef}>
      <Components.Menu size="unset" withBackground itemGap={8}>
        <FlexColumnWithTransition $height={containerHeight}>
          <HOC.WithHeightTransition setContainerHeight={setContainerHeight}>
            <HOC.WithSlider
              direction={stepKey ? "to-left" : "to-right"}
              stepKey={stepKey}
            >
              {stepKey ? (
                <RemoveCircle setStepKey={setStepKey} stepKey={stepKey} />
              ) : (
                <List
                  setStepKey={setStepKey}
                  setCircleListOpen={setCircleListOpen}
                />
              )}
            </HOC.WithSlider>
          </HOC.WithHeightTransition>
        </FlexColumnWithTransition>
      </Components.Menu>
    </CircleListContainer>
  );
};

export default CircleList;
